// Version : 1.0.0
// Author : AGALYA

import { makeApiCall } from '../../../_common/api.utils';
import { API_URL } from '../../../const';

/** ***************** UPDATE ADDRESS EXTRA PROOF START *********************** */
export const addressExtraProofUpdate = (updateAddressExtraProofData: any) => {
	const data = {
		AddressExtraProofToken: updateAddressExtraProofData,
	};
	const url = `${API_URL}updateAddressExtraProof`;
	return makeApiCall(url, data);
};
/** ***************** UPDATE ADDRESS EXTRA PROOF END *********************** */
